import { FunctionComponent } from "preact";

import * as dateish from "@/dateish";

import * as db from "@/db";
import SpeciesTable from "@/ui/species_table";

const MonthPage: FunctionComponent<{
  moy: dateish.MoY
  store: db.Store
}> = ({ moy, store }) => {
  return <div class="content day-view">
    <div class='day-header'>
      <a class='prev' href={ `/month/?id=${dateish.moyPrev(moy)}` } />
      <h2>{ dateish.moyDisplay(moy) }</h2>
      <a class='next' href={ `/month/?id=${dateish.moyNext(moy)}` } />
    </div>
    {/* <ObservationTable query={ store.doySpecies.bind(store, date) } /> */}
    <SpeciesTable query={ store.moySpeciesTable.bind(store, moy) } taxonomy={ store.taxonomy } />
  </div>;
}

export default MonthPage;
